import { useQuery } from "@tanstack/react-query";
import { apiClient } from "../../../../lib/api-client";
import { CFINote } from "../types/CFINote";

export const useGetCFINotes = () => {

    const { data, isLoading, refetch, isRefetching } = useQuery({
        queryKey: ['cfi-notes'],
        queryFn: async () => await apiClient.get('note/cfi-notes') as CFINote[]
    });

    return {
        data: data || [],
        isLoading,
        refetch,
        isRefetching
    };
};
